<template>
    <div class="flex bg-img" style="height: 80vh">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">Asset deleted</h1>
            <vs-button size="large" :class="{'pen': isLoading}" v-on:click="restoreAsset" v-if="id && !hideAction">Restore</vs-button>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            id: {
                type: String,
                default: null
            },
            getAsset: {
                type: Function,
                default: () => {}
            },
            hideAction: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isLoading: false
            }
        },
        methods: {
            restoreAsset() {
                let url = '/deleted-assets/' + this.$route.params.id + '/restore';
                this.isLoading = true;

                this.$axios.get(url).then(res => {
                    this.getAsset();
                    this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Asset restored'})
                }).catch(e => {
                    this.isLoading = false;
                    console.log(e)
                })
            }
        }

    }
</script>
